import '@sprites/icon-sprite.svg?no-inline';

import { whenFound } from './utilities/dom.js';

import Libraries from './libraries/index.js';
import Elements from './elements/index.js';

export default {
  get title() {
    return document.title;
  },

  set title(title) {
    document.title = `${title} · Bremer Philharmoniker`;
  },

  get direction() {
    return document.documentElement.dir || 'ltr';
  },

  get language() {
    return (document.documentElement.lang || 'de-DE').split('-').shift();
  },

  get region() {
    return (document.documentElement.lang || 'de-DE').split('-').pop();
  },

  async polyfill() {
    const polyfills = [];

    if (! ('popover' in HTMLElement.prototype)) {
      polyfills.push(import('@oddbird/popover-polyfill'));
    }

    if (! ('command' in HTMLButtonElement.prototype)) {
      polyfills.push(import('invokers-polyfill'));
    }

    return Promise.all(polyfills);
  },

  async install() {
    await this.polyfill();

    Libraries.install(this);
    Elements.install(this);

    whenFound('.bookmark', (elements) => this.enhanceBookmarks(elements));
    whenFound('form[data-use-ajax]', (elements) => this.enhanceForms(elements));
  },

  /**
   * @param {HTMLElement[]} elements
   */
  enhanceBookmarks(elements) {
    let time = Date.now();

    const handleMouseDown = () => {
      time = Date.now();
    };

    /** @param {Event} event */
    const handleMouseUp = (event) => {
      const target = /** @type {?HTMLElement} */ (
        event.currentTarget
      );

      if (! target) {
        return;
      }

      const link = /** @type {?HTMLAnchorElement} */ (
        target.querySelector('.bookmark__link')
      );

      if (! link) {
        return;
      }

      const isLongPress = (Date.now() - time) >= 200;

      if (isLongPress) {
        return;
      }

      link.click();
    };

    for (const element of elements) {
      element.addEventListener('mousedown', handleMouseDown);
      element.addEventListener('mouseup', handleMouseUp);
    }
  },

  /**
   * @param {HTMLElement[]} elements
   */
  enhanceForms(elements) {
    /** @param {Event} event */
    const handleInput = (event) => {
      const form = /** @type {?HTMLFormElement} */ (
        event.currentTarget
      );

      form?.requestSubmit();
    };

    for (const element of elements) {
      element.setAttribute('data-state', 'enhanced');
      element.addEventListener('input', handleInput);
    }
  },

};